import React, { useEffect } from 'react';
import { initMetaPixel, META_PIXEL_ID } from './utils/metaPixel';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { Problems } from './components/Problems';
import { Solution } from './components/Solution';
import { SamplePages } from './components/SamplePages';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Faqs } from './components/Faqs';
import { FinalComparison } from './components/FinalComparison';
import { SiteFooter } from './components/SiteFooter';
import { StickyBuyBar } from './components/StickyBuyBar';
export function App() {
  useEffect(() => {
    document.documentElement.lang = 'pl';
    document.title = 'Arsenał Nauczyciela Jazzu™ — Cały semestr gitary jazzowej gotowy do uczenia';
    initMetaPixel();
  }, []);
  return <div lang="pl" className="w-full overflow-x-hidden bg-ink pb-[76px] font-sans sm:pb-0" data-id="element-0" data-mp="23w4g45bdvc2y">
      <noscript data-id="element-1" data-mp="3ikh9me1wn113">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="3iiwfuqnezm4a" />
      </noscript>
      <Hero data-id="element-3" data-mp="3rd1azm9kzjpm" />
      <TrustBar data-id="element-4" data-mp="3reccfffk0fdk" />
      <Problems data-id="element-5" data-mp="5yi8qe3h5da" />
      <Solution data-id="element-6" data-mp="6hp9c27i9cj" />
      <SamplePages data-id="element-7" data-mp="4wupmfw6qeo" />
      <Bonuses data-id="element-8" data-mp="5gg5d4r3wxg" />
      <Offer data-id="element-9" data-mp="82kl3wchwbg" />
      <Guarantee data-id="element-10" data-mp="7sxpp6lk59z" />
      <Faqs data-id="element-11" data-mp="2zld43f9knpe6" />
      <FinalComparison data-id="element-12" data-mp="2zlv84y2h77wn" />
      <SiteFooter data-id="element-13" data-mp="2zmo4r67q0h12" />
      <StickyBuyBar data-id="element-14" data-mp="2zn6actg9w7ln" />
    </div>;
}